import * as React from "react";
import { Check, Minus } from "lucide-react";
import { cn } from "../lib";

interface CheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  size?: "sm" | "md";
}

const sizeClasses = {
  sm: "h-5 w-5 rounded-[4px]",
  md: "h-6 w-6 rounded-[6px]",
};

const Checkbox = ({ checked, indeterminate, onChange, className, size = "sm" }: CheckboxProps) => {
  const isCheckedOrIndeterminate = checked || indeterminate;
  return (
    <span
      role="checkbox"
      aria-checked={checked}
      className={cn(
        "flex items-center justify-center border transition-colors cursor-pointer shrink-0",
        isCheckedOrIndeterminate ? "border-[#5B21FF] bg-[#5B21FF]" : "border-[#C8CBE0] bg-white",
        sizeClasses[size],
        className,
      )}
      onClick={(event) => {
        event.stopPropagation();
        onChange?.(!checked);
      }}
    >
      {indeterminate ? (
        <Minus size={14} className="text-white" strokeWidth={3} />
      ) : checked ? (
        <Check size={14} className="text-white" strokeWidth={2.5} />
      ) : null}
    </span>
  );
};

export { Checkbox };
